import { render, staticRenderFns } from "./registerUser.vue?vue&type=template&id=3ab63662&scoped=true"
import script from "./registerUser.vue?vue&type=script&lang=js"
export * from "./registerUser.vue?vue&type=script&lang=js"
import style0 from "./registerUser.vue?vue&type=style&index=0&id=3ab63662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab63662",
  null
  
)

export default component.exports